import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

// Visually hidden but kept in the accessibility tree and focusable; the
// label is the whole tap target via htmlFor
export const ChipInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
  opacity: 0;
`

export const ChipLabel = styled.label`
  ${typeStyle('-ds-font-body-regular')}
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  padding: 0 ${({ theme }) => theme['-ds-space-04']};
  border: 1px solid ${({ theme }) => theme['-ds-border-default']};
  border-radius: ${({ theme }) => theme['-ds-radius-round']};
  background-color: ${({ theme }) => theme['-ds-bg-container-default']};
  color: ${({ theme }) => theme['-ds-text-primary']};
  white-space: nowrap;
  user-select: none;
  cursor: pointer;

  ${ChipInput}:checked + & {
    border-color: ${({ theme }) => theme['-ds-border-interactive-default']};
  }

  ${ChipInput}:focus-visible + & {
    outline: 2px solid ${({ theme }) => theme['-ds-border-interactive-default']};
    outline-offset: 2px;
  }

  ${ChipInput}:disabled + & {
    border-color: ${({ theme }) => theme['-ds-border-disabled']};
    color: ${({ theme }) => theme['-ds-text-disabled']};
    cursor: default;
  }
`

export const ChipWrapper = styled.div`
  position: relative;
  display: inline-flex;
`
